






































import Vue from "vue";
import Search from "@/components/Search.vue";
import FilterClients from "@/components/FilterCustomers.vue";
import FilterCompanies from "@/components/FilterCompanies.vue";

export default Vue.extend({
  name: "BlueTop",
  props: ["action", "name", "name2", "link1", "link2", "active"],
  components: {
    search: Search,
    filter_clients: FilterClients,
    filter_companies: FilterCompanies
  },
  data() {
    return {
      filterClientsVisible: false,
      filterCompaniesVisible: false,
      filters: {
        province: [],
        season_year: null,
        client: null,
        brand: []
      }
    };
  },
  methods: {
    filterButton(buttonChoice: number) {
      this.$store.dispatch("brands/getBrandsList");
      this.$store.dispatch("brandtrends/getBrandTrendsList");
      this.$store.dispatch("clients/getMap", this.$data.filters);
      if (buttonChoice == 1) {
        this.$data.filterClientsVisible = true;
      } else if (buttonChoice == 2) {
        this.$data.filterCompaniesVisible = true;
      }
    },
    handleAction() {
      window.location.href = this.action;
    }
  }
});
